export default function Marquee({ items, testId = "editorial-marquee" }) {
  const row = items.map((it) => `${it}  ·  `).join("");
  return (
    <div className="overflow-hidden border-y border-hair py-6 select-none bg-white" aria-hidden="true" data-testid={testId}>
      <div className="marquee-track">
        {[0, 1].map((i) => (
          <span key={i} className="marquee-chunk">
            {row}
          </span>
        ))}
      </div>
    </div>
  );
}
